let
    /**
     *
     * @type {PortUNAResizeObserver[]}
     * @private
     */
    _observers: PortUNAResizeObserver[]    = [],
    /**
     *
     * @type {boolean}
     */
    listenerAdded = false;

const _requestAnimationFrame = window.requestAnimationFrame
    //@ts-ignore
    || window.mozRequestAnimationFrame
    //@ts-ignore
    || window.webkitRequestAnimationFrame
    || function( callback ){window.setTimeout( callback, 20 );};

function checkObserved()
{
    let i = 0,
        l = _observers.length;

    for( ; i < l; i++ )
    {
        let observer = _observers[i];
        if( observer && !observer.element.parentNode && !observer.element.parentElement )
        {
            observer.callbackDestruct && observer.callbackDestruct();
            _observers.splice( i, 1 );
            continue;
        }
        else if( !observer )
        {
            continue;
        }

        if( observer.checkResize() )
        {
            observer.triggerCallback();
        }
    }

    _requestAnimationFrame( checkObserved );
}

/**
 *
 * @param el
 * @param callback
 * @constructor
 */
class PortUNAResizeObserver
{
    width: number;
    height: number;
    element: HTMLElement;

    callback: VoidFunction;
    callbackDestruct: Nullable<VoidFunction>;

    watchScrollProperties = false;

    constructor(el: HTMLElement, callback: VoidFunction, callbackDestruct: Nullable<VoidFunction> = null, watchScrollProperties = false)
    {
        this.width                 = watchScrollProperties ? el.scrollWidth : el.clientWidth;
        this.height                = watchScrollProperties ? el.scrollHeight : el.clientHeight;
        this.element               = el;
        this.callback              = callback;
        this.callbackDestruct      = callbackDestruct;
        this.watchScrollProperties = watchScrollProperties;
    }

    checkResize(): boolean
    {
        if (this.watchScrollProperties)
        {
            return this.width !== this.element.scrollWidth || this.height !== this.element.scrollHeight;
        }

        return this.width !== this.element.clientWidth || this.height !== this.element.clientHeight;
    }

    triggerCallback(): void
    {
        this.width = this.watchScrollProperties ? this.element.scrollWidth : this.element.clientWidth;
        this.height = this.watchScrollProperties ? this.element.scrollHeight : this.element.clientHeight;
        this.callback.apply( this.element );
    }
}

export function watchResize(el: HTMLElement, callback: VoidFunction, callbackDestruct: Nullable<VoidFunction> = null, watchScrollProperties = false)
{
    let resizeObserver = new PortUNAResizeObserver(el, callback, callbackDestruct, watchScrollProperties);
    _observers.push(resizeObserver);

    if (!listenerAdded)
    {
        _requestAnimationFrame(checkObserved);
        listenerAdded = true;
    }

    return resizeObserver;
}

export function unwatchResize( observer: PortUNAResizeObserver)
{
    if (_observers.includes(observer))
    {
        observer.callbackDestruct && observer.callbackDestruct();
        _observers.splice(_observers.indexOf(observer), 1);
    }
}